import React, { useState, useEffect } from 'react';
import ImpressionTimeline from '../../../../../../../shared/designSystem/components/ImpressionTimeline';

// =============================================================================
// ImpressionTimeline (V2 Transactions expanded row).
//
// V2 facelift: delegated rendering to the shared `<ImpressionTimeline>`
// primitive. This file keeps ownership of the parent-owned side: the
// `getImpressions({ variables: { id } })` Apollo call + the fetch-state
// plumbing (isFetching / hasError / impressionsData). Rendering (publisher
// capsule, meta rows, clickable creative thumb + modal, loading / error /
// empty states) moved entirely into the primitive.
//
// The primitive is configured with `showCreativeThumb` because in this data
// source `imp.media` is a URL — clicking the thumb opens a full-size preview
// modal. That's different from Sign Ups where `imp.media` is a descriptor
// string (handled via `showMediaRow` instead).
// =============================================================================

const ImpressionsTimeLine = ({ transactionId, getImpressions }) => {
  const [impressionsData, setImpressionsData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!transactionId) return;
    setIsFetching(true);
    setHasError(false);
    getImpressions({ variables: { id: transactionId } })
      .then((result) => {
        setImpressionsData(result?.data?.campaignOrderTransactionsImpressionses || []);
        setIsFetching(false);
      })
      .catch((error) => {
        console.error('Error fetching impressions:', error);
        setHasError(true);
        setIsFetching(false);
        setImpressionsData([]);
      });
  }, [transactionId, getImpressions]);

  return (
    <ImpressionTimeline
      impressions={impressionsData}
      loading={isFetching}
      error={hasError}
      emptyText="No impressions found for this transaction."
      showCreativeThumb
    />
  );
};

export default ImpressionsTimeLine;
